import { theme } from '../theme.js';
import { useMyCoverStats } from '../lib/queries.js';

/** Profile: covers given and received this year, and who's behind them. Just information. */
export function MyCoverStatsCard() {
  const { data: s } = useMyCoverStats();
  if (!s) return null;
  const opsTotal = s.ops.weeknight + s.ops.weekend_night + s.ops.day;
  const nothing = !s.given && !s.received && !s.swaps && !opsTotal;
  return (
    <div style={{
      margin: '12px 16px', padding: '12px 14px', borderRadius: 12,
      background: theme.surface, border: `1px solid ${theme.border}`, fontFamily: theme.font,
    }}>
      <div style={{ fontSize: 14, fontWeight: 600, color: theme.text, marginBottom: 8 }}>Last 12 months</div>
      {nothing ? (
        <div style={{ fontSize: 12, color: theme.textMuted }}>Nothing yet — covers, swaps and ops support will show up here.</div>
      ) : (
        <>
          <div style={{ display: 'flex', gap: 8 }}>
            <Stat n={s.given} label="covers you took" />
            <Stat n={s.received} label="times covered" />
            <Stat n={s.swaps} label="swaps" />
          </div>
          {s.helpedMe.length > 0 && (
            <div style={line}>Covered you: {s.helpedMe.map((h) => `${h.displayName}${h.n > 1 ? ` ×${h.n}` : ''}`).join(', ')}</div>
          )}
          {s.iHelped.length > 0 && (
            <div style={line}>You covered: {s.iHelped.map((h) => `${h.displayName}${h.n > 1 ? ` ×${h.n}` : ''}`).join(', ')}</div>
          )}
          {opsTotal > 0 && (
            <div style={line}>Ops support: {s.ops.weeknight} weeknight{s.ops.weeknight === 1 ? '' : 's'} · {s.ops.weekend_night} weekend night{s.ops.weekend_night === 1 ? '' : 's'} · {s.ops.day} day{s.ops.day === 1 ? '' : 's'}</div>
          )}
        </>
      )}
    </div>
  );
}

function Stat({ n, label }: { n: number; label: string }) {
  return (
    <div style={{ flex: 1, padding: '8px 6px', borderRadius: 10, background: theme.surface2, textAlign: 'center' }}>
      <div style={{ fontSize: 20, fontWeight: 800, color: theme.text }}>{n}</div>
      <div style={{ fontSize: 11, color: theme.textMuted, lineHeight: 1.2 }}>{label}</div>
    </div>
  );
}

const line: React.CSSProperties = { fontSize: 12, color: theme.textDim, marginTop: 8 };
